import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import SEO from "@/components/SEO";
import { ChevronLeft } from "lucide-react";

export default function BlogPost() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  useEffect(() => { api.get(`/blog/${slug}`).then((r) => setP(r.data)); }, [slug]);

  if (!p) return <div className="min-h-[60vh] grid place-items-center text-[#86868B]">Loading...</div>;

  return (
    <article className="fade-in" data-testid="page-blog-post">
      <SEO title={p.title} description={p.excerpt} path={`/blog/${p.slug}`} image={p.cover_image} type="article" />
      <div className="max-w-3xl mx-auto px-6 md:px-10 pt-12 pb-16">
        <Link to="/blog" className="inline-flex items-center gap-1 text-sm text-[#86868B] hover:text-[#0066FF]"><ChevronLeft size={14} /> Back to blog</Link>
        <p className="eyebrow mt-8">{p.tags.join(" · ")}</p>
        <h1 className="text-h1 text-[#1D1D1F] mt-4">{p.title}</h1>
        <p className="mt-4 text-[#86868B]">By {p.author} · {new Date(p.created_at).toLocaleDateString()}</p>
      </div>
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <img src={p.cover_image} alt="" className="w-full aspect-[16/9] rounded-3xl object-cover" />
      </div>
      <div className="max-w-3xl mx-auto px-6 md:px-10 py-16 whitespace-pre-line text-lg text-[#1D1D1F] leading-relaxed">
        {p.body}
      </div>
    </article>
  );
}
